export const decorateH1Headlines = () => {
  const h1s = document.querySelectorAll("h1:not(.h2), .as-h1");
  if (!h1s.length) return;

  h1s.forEach((h1) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("relative");

    h1!.parentNode!.insertBefore(wrapper, h1);
    wrapper.appendChild(h1);
    const underline = document.createElement("div");
    underline.classList.add(
      "h1-underline",
      "bg-primary",
      "h-1.5",
      "xs:h-1.5",
      "rounded-full",
      "md:h-3",
      "xl:h-4",
    );

    wrapper.appendChild(underline);

    const updateUnderline = () => {
      const range = document.createRange();
      range.selectNodeContents(h1);
      const rangeRect = range.getBoundingClientRect();
      underline.style.width = `${rangeRect.width}px`;
      underline.style.top = `${rangeRect.height + 5}px`;
    };

    document.fonts.ready.then(() => updateUnderline());
    new ResizeObserver(() => updateUnderline()).observe(h1);
  });
};
